import { useHistory } from 'react-router-dom';
import React from 'react';
import { VaultClearButton } from './MUIStyledComponents';

const BackNavButton: React.FC = () => {
  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };
  return (
    <section >
      <VaultClearButton onClick={goBack}>
        <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
          <path d='M8.46761 9.50076L11.1226 6.84575C11.2623 6.70523 11.3407 6.51514 11.3407 6.317C11.3407 6.11887 11.2623 5.92878 11.1226 5.78825C11.0529 5.71796 10.9699 5.66216 10.8785 5.62409C10.7871 5.58601 10.6891 5.56641 10.5901 5.56641C10.4911 5.56641 10.3931 5.58601 10.3017 5.62409C10.2103 5.66216 10.1273 5.71796 10.0576 5.78825L6.87761 8.96826C6.80731 9.03798 6.75152 9.12093 6.71344 9.21232C6.67537 9.30372 6.65576 9.40175 6.65576 9.50076C6.65576 9.59976 6.67537 9.69779 6.71344 9.78919C6.75152 9.88058 6.80731 9.96353 6.87761 10.0333L10.0576 13.2508C10.1277 13.3203 10.2108 13.3753 10.3022 13.4126C10.3936 13.4499 10.4914 13.4688 10.5901 13.4683C10.6888 13.4688 10.7867 13.4499 10.878 13.4126C10.9694 13.3753 11.0525 13.3203 11.1226 13.2508C11.2623 13.1102 11.3407 12.9201 11.3407 12.722C11.3407 12.5239 11.2623 12.3338 11.1226 12.1933L8.46761 9.50076Z' fill='#F5FAFF'/>
        </svg>
        <p className='back-btn'>Back</p>
      </VaultClearButton>
    </section>
  );
};
export default BackNavButton;
